module.exports = __webpack_public_path__ + "img/Weapon_42.9418fac1.png";